const ContentModerationIcon = () => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M12.5002 6.66536H12.5085M9.16683 16.6654H5.8335C5.17045 16.6654 4.53457 16.402 4.06573 15.9331C3.59689 15.4643 3.3335 14.8284 3.3335 14.1654V5.83203C3.3335 5.16899 3.59689 4.53311 4.06573 4.06426C4.53457 3.59542 5.17045 3.33203 5.8335 3.33203H14.1668C14.8299 3.33203 15.4658 3.59542 15.9346 4.06426C16.4034 4.53311 16.6668 5.16899 16.6668 5.83203V10.832M3.3335 12.4987L6.66683 9.16537C7.44016 8.42121 8.3935 8.42121 9.16683 9.16537L12.5002 12.4987M11.6668 11.6654L12.5002 10.832C13.2735 10.0879 14.2268 10.0879 15.0002 10.832M12.5002 15.832L14.1668 17.4987L17.5002 14.1654"
			stroke="var(--primary-text-color)"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default ContentModerationIcon;
